import { render, staticRenderFns } from "./EmojiTextArea.vue?vue&type=template&id=51296004&scoped=true&"
import script from "./EmojiTextArea.vue?vue&type=script&lang=js&"
export * from "./EmojiTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51296004",
  null
  
)

export default component.exports